/** @type {import('../schema').ProcessDefinition} */
const altaEdificio = {
  id: "alta-edificio",
  name: "Alta de edificio (onboarding)",
  category: "edificios",
  outcome:
    "Un edificio nuevo queda registrado y operativo, con un admin asignado.",
  trigger:
    "Admin/Super Admin crea el edificio desde Edificios / Mis edificios.",
  actors: ["Administrador", "Sistema"],
  status: "COMPLETO",
  description:
    "Registro de un edificio nuevo: datos, geolocalización opcional, creación con ID atómico y asignación de admin(s).",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "admin",
      type: "start",
      label: "Datos del edificio",
      description:
        "Nombre, dirección, departamento, país, padrón, pisos, ascensores y si es complejo (multi-torre).",
      evidence: "src/screens/admin/MisEdificios.jsx",
    },
    {
      id: "s2",
      laneId: "admin",
      type: "decision",
      label: "¿Se carga ubicación?",
      description:
        "El Administrador decide si geolocaliza el edificio (Maps o manual) o lo deja sin ubicación.",
    },
    {
      id: "s3",
      laneId: "sys",
      type: "task",
      label: "Geolocalización",
      description:
        "Resuelve lat/long vía Google Maps o entrada manual (opcional).",
    },
    {
      id: "s4",
      laneId: "sys",
      type: "document",
      label: "Creación del edificio",
      description:
        "Obtiene un buildingid atómico y crea el documento del edificio (active default true).",
      evidence: "src/screens/admin/EditarEdificio.jsx",
    },
    {
      id: "s5",
      laneId: "admin",
      type: "task",
      label: "Asignación de admin",
      description:
        "Vincula el edificio a uno o más admins (relación N:N).",
    },
    {
      id: "s6",
      laneId: "sys",
      type: "task",
      label: "Auditoría",
      description: "Registra la creación del edificio.",
    },
    {
      id: "s7",
      laneId: "sys",
      type: "end",
      label: "Edificio operativo",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3", label: "Con ubicación" },
    { from: "s2", to: "s4", label: "Sin ubicación" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
  ],
};
export default altaEdificio;
